import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAuthRegister = z.any()
export type TagsPostAuthRegister = z.infer<typeof tagsPostAuthRegister>

export const bodyPostAuthRegister = z.object({ "email": z.string().email().min(1), "password": z.string().min(1), "ico": z.string().min(1), "name": z.string().optional() })
export type BodyPostAuthRegister = z.infer<typeof bodyPostAuthRegister>

export const responsePostAuthRegister = z.object({ "payload": z.object({ "name": z.string(), "session_id": z.string(), "type": z.union([z.literal("client"), z.literal("admin")]), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "privileges": z.array(z.string()), "clientRole": z.union([z.literal("READ_ONLY"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]).optional(), "primaryUser": z.boolean().optional(), "accessibleBuildingIdsCount": z.number().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAuthRegister = z.infer<typeof responsePostAuthRegister>

interface IPostAuthRegister extends BaseMethodType {
  tags: TagsPostAuthRegister,
  body: BodyPostAuthRegister,
  response: ResponsePostAuthRegister
}
export const URL = '/auth/register'
export const validation = {
  post: {
    tags: tagsPostAuthRegister,
    body: bodyPostAuthRegister,
    response: responsePostAuthRegister
  }
}
export interface AuthRegister extends BaseRouteType {
  post: IPostAuthRegister
}